import React, { useEffect, useState } from "react";

const AnalyticsPOs: React.FC = () => {
  useEffect(() => {
    (window as any).Highcharts.chart("c3", {
      chart: {
        type: "line",
      },
      title: {
        text: "POs",
      },
      subtitle: {
        text: "Buyer: Tatenda Sibanda",
      },
      xAxis: {
        categories: [
          "Jan 24",
          "Feb 24",
          "Mar 24",
          "Apr 24",
          "May 24",
          "Jun 24",
          "Jul 24",
          "Aug 24",
          "Sep 24",
          "Oct 24",
          "Nov 24",
          "Dec 24",
        ],
        accessibility: {
          description: "Months of the year",
        },
      },
      yAxis: {
        title: {
          text: "Volume",
        },
        labels: {
          format: "{value}",
        },
      },
      tooltip: {
        crosshairs: true,
        shared: true,
      },
      plotOptions: {
        line: {
          marker: {
            radius: 1,
            lineColor: "#5e4cf8",
            lineWidth: 1,
          },
        },
      },
      series: [
        {
          name: "POs",
          marker: {
            symbol: "circle",
          },
          data: [23, 18, 10, 5, 8, 10, 11, 13, 15, 11, 17, 14],
        },
      ],
    });
  }, []);

  return (
    <>
      <div className="card mb-5">
        <div className="collapse show">
          <div id="kt_account_signin_method" className="collapse show">
            <div className="card-body border-top p-9">
              <div className="c3" id="c3">
                Loading...
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { AnalyticsPOs };
